import { EmployeeRole, RoleNamesOrdered } from '../models/employee';

export function orderRoles(responseRoles: EmployeeRole[]): EmployeeRole[] {
  return responseRoles.sort((a, b) =>
    RoleNamesOrdered.indexOf(a.name) > RoleNamesOrdered.indexOf(b.name) ? 1 : -1
  );
}
